(function () {
    'use strict';
    angular.module('Services').service('AccountingUnprocessedShipmentsTable', AccountingUnprocessedShipmentsTable);
    AccountingUnprocessedShipmentsTable.$inject = [
        'TableLiteFactory',
        'toastr',
        '$location',
        'Shipments',
        '$filter',
        'AccountingService',
        'Carrier',
        '$q'
    ];

    function AccountingUnprocessedShipmentsTable(
        TableLiteFactory,
        toastr,
        $location,
        Shipments,
        $filter,
        AccountingService,
        Carrier,
        $q
    ) {
        return function (defaultFilters = {}) {
            const tableData = {
                tableName: 'AccountingUnprocessedShipmentsTable',
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noTableFooter: false
                },
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'ADD NEW INVOICE',
                        tooltip: 'Click to add a new invoice',
                        onClick: () => {
                            $location.path('/accounting/invoices/add');
                        }
                    }, {
                        class: 'btn-primary',
                        label: 'APPROVE FOR CUSTOMER BILLING',
                        tooltip: 'Approve shipments for customer billing',
                        onClick: () => {
                            const selectedItems = tableData.data.filter(item => {
                                return item.isSelected;
                            });
                            const selectedIds = selectedItems.map(item => {
                                return item.id
                            });

                            if (selectedIds.length !== 0) {
                                this.tableData.optionAddOns.buttons[1].loadingIndicator = true;
                                AccountingService.Invoices.approveUnreconciledShipments(success => {
                                    toastr.success("Success", "Selected are now approved for billing.");
                                    tableActions.sendRequest({});
                                    this.tableData.optionAddOns.buttons[1].loadingIndicator = false;
                                }, error => {
                                    toastr.error("Error", error.message);
                                    this.tableData.optionAddOns.buttons[1].loadingIndicator = false;
                                }, selectedIds);
                            } else {
                                toastr.warning("Please select a shipment.", "Warning");
                            }
                        }
                    }]
                },
                headers: [{
                    label: 'SELECT',
                    class: 'text-center',
                    filter: {
                        type: 'checkbox'
                    }
                },
                {
                    label: 'Booking Date',
                    viewName: 'bookingDate',
                    filterName: 'bookingDate',
                    filter: {
                        type: 'datePicker',
                        url: '',
                        class: 'filter-date',
                        toModel: defaultFilters.bookingDate ? new Date(defaultFilters.bookingDate[0]) : '',
                        fromModel: defaultFilters.bookingDate ? new Date(defaultFilters.bookingDate[1]) : '',
                        startDateFilter:'bookingDateStart',
                        endDateFilter:'bookingDateEnd',
                        useArray: true,
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                },
                {
                    label: 'CARRIER PROFILE',
                    viewName: 'carrierProfileName',
                    filterName: 'carrierProfileId',
                    sortName: 'carrierProfile.id',
                    filter: {
                        type: 'autoComplete',
                        placeholder: 'Search',
                        viewName: 'name',
                        model: defaultFilters ? defaultFilters.carrierProfile : '',
                        filterBy: 'id',
                        items: [],
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        },
                        refresh: function (model) {
                            const defer = $q.defer();
                            let filterItems = this.items;
                            Carrier.carrierProfilesCompact((data) => {
                                filterItems.length = 0;
                                angular.forEach(data.content, (profile) => {
                                    filterItems.push(profile);
                                });
                                filterItems.sort((a, b) => a.name.localeCompare(b.name));
                                defer.resolve();
                            }, (error) => {
                                defer.reject();
                            }, { size: 30, name: model });
                            return defer.promise;
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                },
                {
                    label: 'SERVICE PROFILE',
                    viewName: 'serviceProfile',
                    filterName: 'serviceProfileId',
                    filter: {
                        type: 'autoComplete',
                        placeholder: 'Search',
                        viewName: 'displayName',
                        filterBy: 'id',
                        items: [], //List of items shown in dropdown
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        },
                        refresh: function (model) {
                            const defer = $q.defer();
                            let filterItems = this.items;
                            Carrier.serviceProfilesCompact((data) => {
                                filterItems.length = 0;
                                angular.forEach(data.content, (profile) => {
                                    filterItems.push(profile);
                                });
                                filterItems.sort((a, b) => a.name.localeCompare(b.name));
                                defer.resolve();
                            }, (error) => {
                                defer.reject();
                            }, {
                                size: 30,
                                name: model,
                                carrierProfileId: tableActions.activeFilters.carrierProfileId
                            });
                            return defer.promise;
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                },
                {
                    label: 'CONSIGNMENT NO.',
                    viewName: 'consignmentNo',
                    filterName: 'consignmentId',
                    sortName: 'consignmentId',
                    filter: {
                        type: 'text',
                        onSubmit: (header) => {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                },
                {
                    label: 'THIRD PARTY REFERENCE NO.',
                    viewName: 'thirdPartyRefNo',
                    filterName: 'wmsReference',
                    filter: {
                        type: 'text',
                        onSubmit: (header) => {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                },
                {
                    label: 'COMPANY',
                    viewName: 'company',
                    filterName: 'companyName',
                    filter: {
                        type: 'text',
                        onSubmit: (header) => {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'PAYMENT TYPE',
                    viewName: 'paymentType'
                }, {
                    label: 'AMOUNT',
                    viewName: 'amount',
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }],
                data: []
            };

            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: Shipments.unprocessedInvoice,
                callbackFormat: ['success', 'error', 'filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: error => {
                    buildTableData(null);
                    toastr.error(error);
                },
                defaultFilters: angular.extend({
                    size: 20,
                    page: 0,
                    sort: 'id,asc',
                    reconciled: false,
                    paid: false,
                    bookingStatus: 'processed',
                    archived: false,
                }, defaultFilters)
            });

            function buildTableData(data) {
                if (!data) return tableData;
                tableActions.initializeTableData(data);
                angular.forEach(data.content, (item) => {
                    item.bookingDate = $filter('bbaDate')(item.bookingDate);
                    item.consignmentNo = item.consignmentId || 'N/A';
                    item.thirdPartyRefNo = angular.getObjVal(item, 'wmsReference') || 'N/A';
                    item.carrierProfileName = angular.getObjVal(item, 'serviceProfile.carrierProfile.name') || 'N/A';
                    item.serviceProfile = angular.getObjVal(item, 'serviceProfile.name') || 'N/A';
                    item.company = angular.getObjVal(item, 'company.name') || 'N/A';
                    item.paymentType = angular.getObjVal(item, 'paymentDetails') ? 'Credit Card' : 'On Account';
                    item.amount = $filter('bbaCurrency')(item.amount);
                    item.href = `/unprocessed-shipment-details/${item.id}`;
                    tableData.data.push(item);
                });
            }

            this.tableData = tableData;
        }
    }
})()



// WEBPACK FOOTER //
// ./js/services/tables/accountingTables/AccountingUnprocessedShipmentsTable.js